<div class="task-details-page-wrapper">
  <!-- TOP HEADER ROW -->
  <div class="task-details-top-bar">
    <div class="top-bar-left">
      <button type="button" class="back-circle-btn" (click)="goBack()"
        [title]="langService.currentLang === 'mr' ? 'मागे' : 'Back'">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>

      <div class="title-block">
        <h2 class="title-line-main">{{ pageTitleLine1 }}</h2>
        <h3 class="title-line-sub">{{ pageTitleLine2 }}</h3>
      </div>
    </div>

    <!-- Right: Search Input -->
    <div class="top-bar-right">
      <div class="search-box">
        <input type="text" [(ngModel)]="searchText" (input)="onSearchInput($any($event.target).value)"
          [placeholder]="searchPlaceholder" aria-label="Search" />
        <svg class="search-icon-svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
          stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
    </div>
  </div>

  <!-- TABLE CONTAINER CARD -->
  <div class="table-card-container">
    <!-- Loader State -->
    <!-- <div class="details-loader-state" *ngIf="isLoading">
      <div class="details-spinner"></div>
      <p class="details-loader-text">{{ langService.currentLang === 'mr' ? 'माहिती लोड होत आहे...' : 'Loading details...' }}</p>
    </div> -->

    <dx-data-grid *ngIf="!isLoading" #dataGrid [dataSource]="filteredData" [wordWrapEnabled]="true"
      [showBorders]="false" [showRowLines]="false" [showColumnLines]="false" [columnAutoWidth]="true"
      [columnMinWidth]="90" [rowAlternationEnabled]="false" [hoverStateEnabled]="true" [allowColumnResizing]="true"
      width="100%" class="pink-task-grid" [remoteOperations]="false" (onCellPrepared)="onCellPrepared($event)">
      <dxo-load-panel [enabled]="false"></dxo-load-panel>
      <dxo-scrolling mode="standard" useNative="true"></dxo-scrolling>
      <dxo-sorting mode="single"></dxo-sorting>

      <!-- Client-side Pagination Config (referencing Dashboard drilldown report) -->
      <dxo-paging [enabled]="true" [(pageSize)]="pageSize">
      </dxo-paging>
      <dxo-pager [showInfo]="true" [showNavigationButtons]="true">
      </dxo-pager>

      <!-- STATIC COLUMNS -->
      <!-- 1. Sr.No -->
      <dxi-column dataField="sr_no" [caption]="getColCaption('sr_no')" alignment="center" [width]="80"
        cellTemplate="srNoCellTemplate" [allowSorting]="false"></dxi-column>

      <!-- 2. Beneficiary Name -->
      <dxi-column dataField="beneficiary_name" [caption]="getColCaption('beneficiary_name')" alignment="center"
        cellTemplate="beneficiaryCellTemplate"></dxi-column>

      <!-- 3. House No -->
      <dxi-column dataField="house_no" [caption]="getColCaption('house_no')" alignment="center"></dxi-column>

      <!-- 4. Family ID -->
      <dxi-column dataField="family_id" [caption]="getColCaption('family_id')" alignment="center"></dxi-column>

      <!-- 5. Mobile No -->
      <dxi-column dataField="mobile_no" [caption]="getColCaption('mobile_no')" alignment="center"></dxi-column>

      <!-- 6. Visit -->
      <dxi-column dataField="visit" [caption]="getColCaption('visit')" alignment="center"
        [calculateSortValue]="visitSortValue"></dxi-column>

      <!-- 7. Action -->
      <dxi-column dataField="action" [caption]="getColCaption('action')" alignment="center" [width]="160"
        cellTemplate="actionCellTemplate" [allowSorting]="false"></dxi-column>

      <!-- TEMPLATES -->
      <!-- Sr.No Template (Client-side sequential index) -->
      <div *dxTemplate="let cell of 'srNoCellTemplate'">
        <span class="sr-no-text">
          {{ cell.component.pageIndex() * cell.component.pageSize() + cell.rowIndex + 1 }}
        </span>
      </div>

      <!-- Beneficiary Name Template -->
      <div *dxTemplate="let cell of 'beneficiaryCellTemplate'">
        <span class="beneficiary-name-text">
          {{ langService.currentLang === 'mr' ? (cell.data.beneficiary_name_mr || cell.data.beneficiary_name) :
          cell.data.beneficiary_name }}
        </span>
      </div>

      <!-- Action Button Template: Pink "✓ Do Now" pill -->
      <div *dxTemplate="let cell of 'actionCellTemplate'">
        <button type="button" class="btn-do-now" (click)="onDoIt(cell.data)"
          [title]="langService.currentLang === 'mr' ? 'करा' : 'Do It'">
          <span class="check-icon">✓</span>
          <span>{{ langService.currentLang === 'mr' ? 'करा' : 'Do It' }}</span>
        </button>
      </div>
    </dx-data-grid>
  </div>
</div>